import React, { ReactNode } from 'react';
import {
  CompanyTargetTypeEnum,
  ItemStatusEnum
} from '../../../graphql/graphql';
import { PriceViewMode } from '../../GeneralAdsPage/types';

export enum SwiperDirection {
  Next = 'next',
  Prev = 'prev'
}

export interface Company {
  id: string;
  name?: string | null;
  targetType?: CompanyTargetTypeEnum | null;
}

export interface Location {
  fullName?: string | null;
  id: string;
  latitude?: number | null;
  locationGroup?: object;
  locationGroupId?: string;
  longitude?: number | null;
  name?: string | null;
  parent?: Location | null;
  path?: string;
  slug?: string;
}

export interface City {
  id: string;
  latitude?: number | null;
  locations?: Location[];
  longitude?: number | null;
  name?: string | null;
  path?: string;
  slug?: string;
}

export interface BaseItem {
  area?: {
    units?: string | null;
    value?: number | null;
  };
  city?: City;
  company?: Company | null;
  isFeatured?: boolean;
  floor?: number | null;
  floors?: number | null;
  hasBillOfSale?: boolean | null;
  hasMortgage?: boolean | null;
  hasInternalLoan?: boolean;
  hasRepair?: boolean | null;
  id?: string;
  isBusiness?: boolean;
  isLeased?: boolean | null;
  isVipped?: boolean;
  isPaidDaily?: boolean | null;
  location?: Location | null;
  path?: string;
  photos?: { [key: string]: string }[];
  photosCount?: number;
  price?: {
    currency: string;
    value?: number | null;
    perAre?: number | null;
    total?: number | null;
  };
  rooms?: number | null;
  updatedAt?: string;
  state?: ItemStatusEnum;
}

export interface BaseItemProps extends BaseItem {
  stat?: string;
  itemId?: string;
  inBookmarks?: boolean;
  shouldUpdateCache?: boolean;
  removeItemHandle?: () => void;
  setCarousel?: (value: string) => void;
  carousel?: boolean;
  cypress?: string;
  hideExcessItems?: boolean;
  hasHorizontalScroll?: boolean;
  bulkItem?: boolean;
  showBookmark?: boolean;
  'cypress-card'?: string;
  handleClick?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  checkedItems?: number[];
  button?: ReactNode;
  deskCountItemsPerRows?: number;
  hideLabels?: boolean;
  showStateLabel?: boolean;
  forceTargetBlank?: boolean;
  business?: { id: string } | undefined | null;
  priceView?: PriceViewMode | null;
  priority?: boolean;
  forceLargeImage?: boolean;
  bookmarkStat?: string;
}

export interface GetLocationName {
  city: BaseItemProps['city'];
  location: BaseItemProps['location'];
}

export interface ParamsList {
  rooms: BaseItemProps['rooms'];
  area: BaseItemProps['area'];
  floor: BaseItemProps['floor'];
  floors: BaseItemProps['floors'];
}

export interface DisplayPriceParams {
  mode?: PriceViewMode | null;
  price: {
    full?: number | null;
    currency?: string;
    perAre?: number | null;
    units?: string | null;
  };
  isLeased?: boolean | null;
  isPaidDaily?: boolean | null;
}

export interface DisplayPriceResult {
  value?: string | number;
  currency?: string;
  cy: string;
  priceUnit?: { text: string; cy: string };
  rentSuffix?: { type: string; cy: string };
}

export interface ItemCardStylesProps {
  $hideExcessItems?: boolean;
  $hasHorizontalScroll?: boolean;
  $deskCountItemsPerRows?: number;
}
